import RichTextEditor from "./components/rich-text-editor"
export default RichTextEditor